export default __webpack_public_path__ + "static/media/Tactician's Gauntlets.78e73301.jpg";